module.exports = ":host {\n  z-index: 300;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 50px;\n  width: 40px;\n  margin-right: 10px;\n  cursor: pointer;\n  color: white;\n  line-height: 50px;\n  -webkit-touch-callout: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-player/vg-chromecast/vg-chromecast.media/vg-chromecast.media.style.scss
// module id = 833
// module chunks = 2